import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppFooterComponent } from './footer-ui/components/footer.component';
import { LegalNoticeComponent } from './legal-notice-ui/components/legal-notice.component';
import { PrivacyPolicyComponent } from './privacy-policy-ui/compopnents/privacy-policy.component';
import { CustomTranslatorModule, SharedModule } from 'ngx-esprio-shared';
import { JointResponsibilityAgreementComponent } from './joint-responsibility-agreement-ui/components/joint-responsibility-agreement.component';

@NgModule({
  declarations: [
    AppFooterComponent,
    LegalNoticeComponent,
    PrivacyPolicyComponent,
    JointResponsibilityAgreementComponent,
  ],
  imports: [CommonModule, CustomTranslatorModule, SharedModule],
  exports: [AppFooterComponent],
})
export class ViewsModule {}
